import { ApiClientBase as ApiClient, CaseType, ExportScope } from '../generated/apiClient.generated';

import { HttpStatusCode, createCustomFetch } from '@steinpilz/react-ux/web-api';

import { baseUrl } from './constants';

import { loginUrl } from './utils';

const redirectToLogin = () => {
  window.location.href = loginUrl();
  return new Promise<Response>(() => {});
};

const customFetch = createCustomFetch({
  withNoMimeTypeHeaders: true,
  beforeRequest: (init?: RequestInit) => {
    return {
      ...init,
      redirect: 'manual',
    };
  },
  afterResponse: async (resp) => {
    if (resp.status === HttpStatusCode.UNAUTHORIZED || resp.status === 0) {
      return redirectToLogin();
    }

    if (resp.redirected && resp.status === HttpStatusCode.OK) {
      const text = await resp.clone().text();

      if (text.includes('login')) {
        return redirectToLogin();
      }
    }

    return resp;
  },
});

export const apiClient = new ApiClient(baseUrl, { fetch: customFetch });

export const getCaseExportUrl = (
  caseType: CaseType,
  caseId: string,
  scope: ExportScope,
  lang: string,
  timeZone: string,
): string => {
  const casePath = caseType === CaseType.Accident ? 'accident-cases' : 'damage-cases';
  const query = new URLSearchParams({ scope, lang, timeZone });
  return `${baseUrl}/${casePath}/${encodeURIComponent(caseId)}/export?${query.toString()}`;
};

const toContentBlob = (r: Response): Promise<Blob> => {
  if (!r.ok) {
    throw new Error(`Content request failed with status ${r.status}`);
  }
  return r.blob();
};

export const fetchPhotoBlob = (id: string): Promise<Blob> =>
  customFetch(`${baseUrl}/damage-photos/${id}/content`).then(toContentBlob);

export const fetchAccidentSketchBlob = (id: string): Promise<Blob> =>
  customFetch(`${baseUrl}/accident-case-sketches/${id}/content`).then(toContentBlob);

export const fetchDamageSketchBlob = (id: string): Promise<Blob> =>
  customFetch(`${baseUrl}/damage-case-sketches/${id}/content`).then(toContentBlob);

export const fetchWorkflowDocumentBlob = (
  caseType: CaseType,
  caseId: string,
  documentId: string,
): Promise<Blob> => {
  const path = caseType === CaseType.Accident ? 'accident-cases' : 'damage-cases';
  return customFetch(`${baseUrl}/${path}/${caseId}/workflow/documents/${documentId}/content`).then(
    toContentBlob,
  );
};
